import { Component } from '@angular/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSlideToggleChange, MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ThemePalette } from '@angular/material/core';
import { MatCardModule } from '@angular/material/card';
import { FormsModule } from '@angular/forms';
import { TeamMessageService } from '../service/team-message.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
@Component({
  selector: 'app-set-apex-id',
  standalone: true,
  imports: [
    CommonModule,
    MatToolbarModule,
    MatFormFieldModule, 
    MatInputModule,
    MatSlideToggleModule,
    MatCardModule,
    FormsModule,
    MatProgressSpinnerModule,
    MatIconModule,
    RouterLink,
  ],
  templateUrl: './set-apex-id.component.html',
  styleUrl: './set-apex-id.component.css'
})
export class SetApexIdComponent {
  color: ThemePalette = 'accent';
  checked = false;
  apexIdInput = '';
  businessType = '';
  country = '';
  apexIdOverrideStatus = false;
  isLoading = false;
  teamMessageArray = [];
  constructor(    
    private teamMessageService: TeamMessageService,    
  ) { 

  }
  apexIdOverrideToggleChange(event: MatSlideToggleChange) {
    console.log('toggle', event.checked);
    if(event.checked){
      this.isLoading = true;
      this.teamMessageService.getTeamMessageByApexId(this.apexIdInput).subscribe(responseTeamMessageObject => {
        if(responseTeamMessageObject.length === 0){
          this.teamMessageArray = [];
        }
        else{
          this.teamMessageArray = responseTeamMessageObject;
          let driverBusinessType = responseTeamMessageObject[0].driver.businessType;
          this.businessType = driverBusinessType;
          let driverCountry = responseTeamMessageObject[0].driver.terminal.country;
          this.country = driverCountry;
          let driverStartDate = responseTeamMessageObject[0].driver.startDate;
          let dashboardTeamMessageDetails = [];
          dashboardTeamMessageDetails = responseTeamMessageObject[0].dashboardTeamMessageDetails;
          let driverId = responseTeamMessageObject[0].driver.driver_Id;
          let overrideObject : any = {driverId: driverId, driverCountry: driverCountry, driverBusinessType: driverBusinessType, apexid:this.apexIdInput, 
            driverStartDate:driverStartDate, dashboardTeamMessageDetails:dashboardTeamMessageDetails };
          localStorage.setItem('overrideObject', JSON.stringify(overrideObject));
        }
        this.isLoading = false;
      });
    }
    else{
      localStorage.removeItem("overrideObject");
      let apexId = localStorage.getItem("apexid"); 
      if(apexId !== null){
        this.apexIdInput = apexId;
        this.country = localStorage.getItem("driverCountry")!;
        this.businessType = localStorage.getItem("driverBusinessType")!;
      }
    }
  }
  ngOnInit(): void {
    let overrideObjectString = localStorage.getItem("overrideObject");
    if(overrideObjectString === null){
      this.apexIdOverrideStatus = false;
      let apexId = localStorage.getItem("apexid"); 
      if(apexId !== null){
        this.apexIdInput = apexId;
        this.country = localStorage.getItem("driverCountry")!;
        this.businessType = localStorage.getItem("driverBusinessType")!;
      }       
    }
    else{
      this.apexIdOverrideStatus = true;
      let overrideObject = JSON.parse(overrideObjectString);
      this.apexIdInput = overrideObject.apexid;
      this.country = overrideObject.driverCountry;
      this.businessType = overrideObject.driverBusinessType;
    }
  }
}
